
export const commonService = {
    removeTmpImage: (file) => window.axios.post('removeTmpImage',{file}),
}